import React from 'react';
import replaceCommaWithDot from '../../../helpers/utils/replaceCommaWithDot';
import EstimationBlock from '../templates/common/estimationBlock';
import SliderControllerBlock from '../templates/common/sliderControllerBlock';

export default function template(context) {
    const calc = context.calc,
      model = calc.state.model;

  const estimationData = [
    {
      label: calc.l10n('CALCULATOR_MONTHLY_PAYMENT_NEW'),
      value: `${replaceCommaWithDot(model.getRequiredPayment().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_SUM_NEW_DESIGN'),
      value: `${model.getCreditSum().toLocaleString()} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_NEW_ESTIMATION_REAL_YEAR_RATE'),
      value: `${replaceCommaWithDot(model.getRealInterestRate())} ${calc.l10n('CALCULATOR_CREDIT_PERCENT')}`,
    },
    {
      label: calc.l10n('CALCULATOR_CREDIT_PAYMENTS'),
      value: `${model.getBankCreditTerm()}`,
    },
    {
      label: calc.l10n('CALCULATOR_OVERPAYMENT_NEW_2'),
      value: `${replaceCommaWithDot(model.getOverpayment().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
    {
      label: calc.l10n('CALCULATOR_TOTAL_COST'),
      value: `${replaceCommaWithDot(model.getCreditCost().toLocaleString())} ${calc.l10n('UAH_ICON')}`,
    },
  ];

  return (
    <div className="calculator-new__content">
      <div className="calculator-new__top top-calculator-new">
        <div className="top-calculator-new__body">
          <h2 className="top-calculator-new__title">{calc.l10n('CALCULATOR_NEW_TITLE')}</h2>
          <div className="top-calculator-new__base-rate">
            {calc.l10n("CALCULATOR_NEW_PBP_YEAR_PERCENT")} {model.getBasicRate() + calc.l10n("PERCENT")}
          </div>
        </div>
      </div>
      <div className="calculator-new__bottom">
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_SUM_CONTROLLERS_TITLE')}
          inputName="creditSum"
          value={model.getCreditSum()}
          currency={calc.l10n('UAH_ICON')}
          min={model.getMinSumEdge()}
          max={model.getMaxSumEdge()}
          step={model.getSumStep()}
          currencyOffset={calc.state.valueWith}
          hiddenValueRef={calc.hiddenValue}
          onInputChange={calc.handleChangeInput}
          onInputBlur={calc.blurChangeInput}
          onRangeChange={calc.handleChange}
          showError={calc.state.error}
          errorText={`${calc.l10n("CALCULATOR_CREDIT_ERROR_TEXT")} ${model.getMinSumEdge()} ${calc.l10n('UAH_ICON')}`}
        />
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_SHOP_PAYMENTS_CONTROLLERS_TITLE')}
          inputName="shopCreditTerm"
          value={model.getCreditTerm()}
          min={model.getMinTermEdge()}
          max={model.getMaxTermEdge()}
          step="1"
          onRangeChange={calc.handleChange1}
          showError={false}
          readOnly={true}
        />
        <SliderControllerBlock
          title={calc.l10n('CALCULATOR_NEW_DESITED_PAYMENTS_CONTROLLERS_TITLE')}
          inputName="bankCreditTerm"
          value={model.getBankCreditTerm()}
          min={model.getMinTermEdge()}
          max={model.getMaxTermEdge()}
          step="1"
          onRangeChange={calc.handleChange2}
          showError={false}
          readOnly={true}
        />
        <EstimationBlock
          title={calc.l10n('CALCULATOR_NEW_ESTIMATION_PAYMENTS_TITLE')}
          items={estimationData}
        />
      </div>
    </div>
  );
}
